import React from 'react';

import { Box } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import { getPanelContent } from './PanelRegistry';

interface PanelWrapperProps {
  panelId: string;
}

const PanelWrapper: React.FC<PanelWrapperProps> = observer(({ panelId }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        border: '1px solid',
        borderColor: 'neutral.outlinedBorder',
        bgcolor: 'background.surface',
        overflow: 'hidden'
      }}
    >
      {getPanelContent(panelId)}
    </Box>
  );
});

export default PanelWrapper;
